<template>
  <nav class="home_box">
    <img class="bg_img" src="@/assets/img/bg.png" alt />
    <div class="text_box">
      <p>亲爱的360er</p>
      <p>
        该流程
        <span style="color:#f7fc00;">已迁移【推推】</span>,请扫描二维码下载【推推】进行审批。
      </p>
      <p>
        <span>注：Android手机使用蓝信扫码后，需点击右</span>
        <span style="display:inline-block;text-indent:2em;">上角“...”更多，选择“用其他应用打开”。</span>
      </p>
    </div>
  </nav>
</template>

<script>
  export default {
    name: 'new',
    data () {
      return {
        count: 0
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.home_box {
  min-height: 100vh;
  position: relative;
  .bg_img {
    width: 100%;
  }
  .text_box {
    width: 8.6rem;
    position: absolute;
    top: 6.2rem;
    left: 0.7rem;
    font-size: 0.42rem;
    color: #fff;
    line-height: 0.5rem;
    p {
      padding-bottom: 0.4rem;
    }
  }
}
</style>


